import React from 'react';
import Link from 'next/link';
import { CircleCheckBig } from 'lucide-react';
import { NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuTrigger } from '@/shadcn/components/NavigationMenu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TemplatesDesktop = _ref => {
  let {
    filters
  } = _ref;
  return /*#__PURE__*/_jsxs(NavigationMenuItem, {
    children: [/*#__PURE__*/_jsx(NavigationMenuTrigger, {
      children: /*#__PURE__*/_jsx(Link, {
        href: '/templates',
        children: "Templates"
      })
    }), /*#__PURE__*/_jsx(NavigationMenuContent, {
      className: "min-w-[calc(100vw-4rem)] p-12 2xl:min-w-[calc(1400px-4rem)]",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex justify-between gap-x-[52px]",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "w-1/2 max-w-[510px] py-2.5",
          children: [/*#__PURE__*/_jsx("div", {
            className: "mb-10 text-xs uppercase tracking-widest text-muted-foreground",
            children: "Templates"
          }), /*#__PURE__*/_jsx("div", {
            className: "grid grid-cols-2 gap-6",
            children: filters.map(temp => /*#__PURE__*/_jsxs(NavigationMenuLink, {
              href: `/templates#${temp.name}`,
              className: "group flex items-center gap-5 capitalize",
              children: [/*#__PURE__*/_jsx("div", {
                className: "group-hover:opacity-60",
                children: /*#__PURE__*/_jsx(CircleCheckBig, {
                  className: "size-6"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "text-base",
                children: temp.name
              })]
            }, `templates-${temp.name}`))
          })]
        }), /*#__PURE__*/_jsx(NavigationMenuLink, {
          href: "/templates",
          className: "group max-w-[604px] flex-1",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex h-full rounded-lg bg-secondary/30 group-hover:bg-secondary/80 group-focus:bg-secondary/80",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-2/5 max-w-[210px] shrink-0 text-clip rounded-lg",
              children: /*#__PURE__*/_jsx("img", {
                src: "/img/pages/templates/featured-image.webp",
                alt: "Phones with previews of templates",
                className: "size-full object-cover object-center"
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex flex-col p-5 xl:p-8",
              children: [/*#__PURE__*/_jsx("div", {
                className: "mb-8 text-xs uppercase tracking-widest text-muted-foreground",
                children: "New Additions"
              }), /*#__PURE__*/_jsxs("div", {
                className: "mt-auto",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "mb-4 text-xl",
                  children: "Start with easy to use templates"
                }), /*#__PURE__*/_jsx("div", {
                  className: "text-sm font-normal text-muted-foreground",
                  children: "Publish a new dashboard or calculator in seconds using one of our pre-made templates."
                })]
              })]
            })]
          })
        })]
      })
    })]
  });
};
export const TemplatesMobile = _ref2 => {
  let {
    filters,
    open,
    submenu
  } = _ref2;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: open && submenu === 'templates' && /*#__PURE__*/_jsxs("div", {
      className: "fixed inset-0 top-[48px] flex w-full flex-col overflow-auto bg-white lg:hidden",
      children: [/*#__PURE__*/_jsx("div", {
        className: "px-8 py-3.5 text-xs uppercase tracking-widest text-muted-foreground",
        children: "Templates"
      }), /*#__PURE__*/_jsx("div", {
        children: filters.map(temp => /*#__PURE__*/_jsxs("a", {
          href: `/templates#${temp.name}`,
          className: "group flex w-full items-start gap-x-4 border-t border-border px-8 py-7 text-left hover:bg-accent",
          children: [/*#__PURE__*/_jsx("div", {
            className: "shrink-0",
            children: /*#__PURE__*/_jsx(CircleCheckBig, {
              className: "size-6"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "text-base capitalize",
            children: temp.name
          })]
        }, `templates-${temp.name}`))
      }), /*#__PURE__*/_jsxs("div", {
        className: "bg-secondary/30 px-8 pb-16 pt-8",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mb-7 text-xs uppercase tracking-widest text-muted-foreground",
          children: "New Additions"
        }), /*#__PURE__*/_jsxs("a", {
          href: "/templates",
          className: "block space-y-6",
          children: [/*#__PURE__*/_jsx("div", {
            className: "text-clip rounded-lg",
            children: /*#__PURE__*/_jsx("img", {
              src: "/img/pages/templates/og-image.webp",
              alt: "Placeholder image",
              className: "aspect-[2/1] size-full object-cover object-center"
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("div", {
              className: "mb-1.5 text-base",
              children: "View all templates"
            }), /*#__PURE__*/_jsx("div", {
              className: "text-sm font-normal text-muted-foreground",
              children: "Publish a new dashboard or calculator in seconds using one of our pre-made templates."
            })]
          })]
        })]
      })]
    })
  });
};